import React from 'react';
import {injectIntl, intlShapre} from 'react-intl';
import DocumentTitle from 'react-document-title';
import {Button, Container, Dimmer, Dropdown, Grid, Header, Loader, Search} from 'semantic-ui-react';
import debounce from 'lodash/debounce';

import FeaturedBreak from "pages/FeaturedManager/FeaturedBreak";
import {dbGet, dbPost} from 'utils/ajaxUtils';
import {makeDBContentImageUrl} from "../../utils/DBUtils";

class FeaturedManagerPage extends React.Component {

  // Initialize an empty break list and empty search results
  constructor(props) {
    super(props);
    this.state = {
      featuredBreaks: [],
      searchResults: null,
      publishing: false,
      language: 'en-US',
      loadingItems: false
    };
  }

  // On mount, get the breaks
  componentDidMount() {
    this.getFeaturedBreaks();
  }

  /*
    Make the ajax call to get the full list of breaks for the given platform
    and language.
  */
  getFeaturedBreaks = (successCallback, errorCallback) => {
    var data = {
      platform: 'DAILYBREAK',
      language: this.state.language
    };

    this.setState({ loadingItems: true });  // TODO Only make ajax call as callback of state being updated

    dbGet("breaks/featuredorder", data).subscribe({
      next: (response) => {
        this.setState({ featuredBreaks: response.response.featuredBreaks, loadingItems: false });
      }
    });
  }

  /*
    Make the ajax call to persist the updated order based on an array
    of break ids.
  */
  saveFeaturedBreaks = (breakIds) => {
    var data = {
      breakIds: breakIds,
      platform: 'DAILYBREAK',
      language: this.state.language
    };

    dbPost("breaks/save/featuredorder", data).subscribe({
      next: (response) => {
        // Do nothing, we already update based on where the user moved the breaks
      }
    });
  }

  /*
    Remove item with matching id and updated save the list
  */
  deleteItem = (id) => {
    let breakIds = [];
    let updatedFeaturedBreaksArray = [];
    for (var i=0; i<this.state.featuredBreaks.length;i++) {
      let featuredBreak = this.state.featuredBreaks[i];
      if ( featuredBreak.id !== id ) {
        breakIds.push(featuredBreak.id);
        updatedFeaturedBreaksArray.push(featuredBreak);
      }
    }

    this.setState({
      featuredBreaks: updatedFeaturedBreaksArray
    });

    this.saveFeaturedBreaks(breakIds);
  }

  publishOrder = () => {
      let data = {
          platform: 'DAILYBREAK',
          language: this.state.language
      };

      this.setState({
        publishing: true
      });

      dbPost("breaks/featuredorder/publish", data).subscribe({
        next: (response) => {
          this.setState({ publishing: false });
        }
      });
  }

  onLoadingFeaturedBreaksError = () => {
    // TODO
  }

  /*
    Called when an item is dropped.  Loop through all items and
    add their ids to the breakIds array, unless it is the id of the
    dropped item.  We only want to add the target item into the new drop
    index position, so if we're on that interation add it to the list there
    instead of it's old location which would match the id.
  */
  onDropped = (itemDropped, targetItem) => {
    let breakIds = [];
    let updatedFeaturedBreaksArray = [];

    for (var i=0;i<this.state.featuredBreaks.length;i++) {
      let featuredBreak = this.state.featuredBreaks[i];
      if ( i === itemDropped.index ) {
        breakIds.push(targetItem.id);
        updatedFeaturedBreaksArray.push(targetItem);
      }
      if ( featuredBreak.id !== targetItem.id ) {
        breakIds.push(featuredBreak.id);
        updatedFeaturedBreaksArray.push(featuredBreak);
      }
    }

    this.setState({
      featuredBreaks: updatedFeaturedBreaksArray
    });

    this.saveFeaturedBreaks(breakIds);
  }

  /*
    When a new search query is entered, make the ajax request to
    get updated results and update the state with those results.
  */
  handleSearchChange = (e, { value }) => {
    let filters = [
      { 'field':'platform', 'value': 'DAILYBREAK' },
      { 'field': 'lang', 'value': this.state.language }
    ];
    var data = {
      query: value,
      filters: filters
    };

    dbGet("resource/break/search", data).subscribe({
      next: (response) => {
        this.setState({
          // search results need a key to re-render correctly
          searchResults: response.response.object.map(result => ({
            id: result.id,
            cardImageId: result.cardImageId,
            title: result.title || result.permalink, // Default search display to show permalink if title wasn't set yet
            image: result.cardImageId ? makeDBContentImageUrl(result.cardImageId) : null, // So image displays in search results
            description: result.description,
            key: result.challengeId
          }))
        });
      }
    });
  };

  /*
    When a user selects a search result, add it to the featured break
    list at the top and persist the new order by calling saveFeaturedBreaks.
  */
  handleResultSelect = (e, { result }) => {

    // TODO: If already in list ignore and show warning?

    var breakList = this.state.featuredBreaks;
    breakList.unshift(result);
    this.setState({
      featuredBreaks: breakList
    });

    // TODO: Make this a utility to get id list from objects
    let breakIds = [];
    if ( breakList && breakList.length > 0 ) {
        for ( var i=0; i< breakList.length; i++ ) {
          breakIds.push(breakList[i].id);
        }
        this.saveFeaturedBreaks(breakIds);
    }
  }

  onChangeSite = (e, {value}) => {
    this.setState({ language: value}, this.getFeaturedBreaks);
  }

  render() {

    return (
      <DocumentTitle title={"Featured Manager"}>
        <Container className="featured-manager-container">
          <Grid>
            <Grid.Row>
              <Grid.Column width={5}>
                <Header as='h1'>Featured Manager</Header>
              </Grid.Column>
              <Grid.Column width={4}>
                <Search onSearchChange={debounce(this.handleSearchChange, 500, { leading: true })}
                        onResultSelect={this.handleResultSelect}
                        results={this.state.searchResults}  />
              </Grid.Column>
              <Grid.Column width={4}>
                <Dropdown onChange={this.onChangeSite} selection options={[
                  {
                    text: 'Dailybreak',
                    value: 'en-US'
                  },
                  {
                    text: 'El Dailybreak',
                    value: 'es-LA'
                  },
                  {
                    text: 'Dailybreak UK',
                    value: 'en-GB'
                  }
                ]}/>
              </Grid.Column>
              <Grid.Column width={3}>
                <Button onClick={this.publishOrder} loading={this.state.publishing}>
                  Publish Order
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Dimmer.Dimmable>
          <Dimmer active={this.state.loadingItems}/>
          <Loader active={this.state.loadingItems}/>
          { this.state.featuredBreaks.map((featuredBreak, index) => {
              return (
                <FeaturedBreak  id={featuredBreak.id}
                                imageId={featuredBreak.cardImageId}
                                challengeId={featuredBreak.challengeId}
                                starts={featuredBreak.starts}
                                completes={featuredBreak.completes}
                                permalink={featuredBreak.permalink}
                                title={featuredBreak.title}
                                index={index}
                                onDropped={this.onDropped}
                                deleteItem={this.deleteItem}/>
              );
            })
          }
          </Dimmer.Dimmable>
        </Container>
      </DocumentTitle>
    );
  }
}

FeaturedManagerPage.propTypes = {

};

export default injectIntl(FeaturedManagerPage);



// WEBPACK FOOTER //
// ./public/pages/FeaturedManager/FeaturedManagerPage.jsx